module.exports = __webpack_public_path__ + "static/media/SideMenu_Accounts.f33a40c4.svg";